import styled from 'styled-components';

export const StyledListItem = styled.li`
  display: inline-block;
  margin-right: 0.25rem;
  font-size: 1rem;
`;
